import { RangeReferencePoint, RangeReferenceUnit } from '@itonics/filters';

/**
 * Date picker options id.
 */
export const DatePickerOptionsId = {
  LAST_7_DAYS: `-7${RangeReferenceUnit.DAYS}${RangeReferencePoint.DATE_NOW}`,
  PAST_1_MONTH: `-1${RangeReferenceUnit.MONTHS}${RangeReferencePoint.DATE_NOW}`,
  PAST_1_QUARTER: `-3${RangeReferenceUnit.MONTHS}${RangeReferencePoint.DATE_NOW}`,
  PAST_1_YEAR: `-1${RangeReferenceUnit.YEARS}${RangeReferencePoint.DATE_NOW}`,
  PAST_2_YEAR: `-2${RangeReferenceUnit.YEARS}${RangeReferencePoint.DATE_NOW}`,
  PAST_5_YEAR: `-5${RangeReferenceUnit.YEARS}${RangeReferencePoint.DATE_NOW}`,
  FROM_START_OF_MONTH: `0${RangeReferenceUnit.DAYS}${RangeReferencePoint.DATE_MONTH_START}`,
  FROM_START_OF_YEAR: `0${RangeReferenceUnit.DAYS}${RangeReferencePoint.DATE_YEAR_START}`
};
